import React from 'react';
import PropTypes from 'prop-types';
import Maybe from 'react-maybe';
import { Icon } from '@ers/ui';

const Consent = ({ accepted, children }) => (
    <div className="consent">
        <Maybe of={accepted} either={<Icon name="accepted" />} orElse={<Icon name="refused" />} />
        {children}
    </div>
);

Consent.propTypes = {
    accepted: PropTypes.bool
};
Consent.defaultProps = {
    accepted: false
};
export default Consent;
